import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDateFormat]',
  standalone: true,
})
export class DateFormatDirective {
  @Input() maxDate?: Date;

  constructor(private el: ElementRef, private ngControl: NgControl) {}

  @HostListener('input', ['$event.target.value'])
  onDateInputChange(value: string): void {
    const sanitizedValue = value.replace(/[^0-9]/g, '');
    const today = new Date();
    let formattedValue = '';

    // Format based on input length
    if (sanitizedValue.length <= 2) {
      formattedValue = sanitizedValue;
    } else if (sanitizedValue.length <= 4) {
      formattedValue = `${sanitizedValue.slice(0, 2)}-${sanitizedValue.slice(
        2
      )}`;
    } else if (sanitizedValue.length <= 8) {
      formattedValue = `${sanitizedValue.slice(0, 2)}-${sanitizedValue.slice(
        2,
        4
      )}-${sanitizedValue.slice(4)}`;
    }

    const [day, month, year] = formattedValue
      .split('-')
      .map((part) => parseInt(part, 10));

    const currentYear = today.getFullYear();
    const minYear = currentYear - 125;

    // Validation checks
    const invalidConditions =
      formattedValue.startsWith('00') ||
      formattedValue.substring(3, 5) === '00' ||
      formattedValue.substring(6, 7) === '0' ||
      (day && day > 31) ||
      (month && month > 12) ||
      (year &&
        year.toString().length === 4 &&
        (year > currentYear || year < minYear));

    if (invalidConditions) {
      this.updateValue('');
      return;
    }

    const inputDate = new Date(year, month - 1, day);

    const todayFormatted = `${today.getDate().toString().padStart(2, '0')}-${(
      today.getMonth() + 1
    )
      .toString()
      .padStart(2, '0')}-${today.getFullYear()}`;

    // Final value selection
    if (sanitizedValue.length === 8 && inputDate > today) {
      this.updateValue(todayFormatted);
    } else {
      this.updateValue(formattedValue);
    }
  }

  private updateValue(value: string): void {
    if (this.ngControl && this.ngControl.control) {
      this.ngControl.control.setValue(value, { emitEvent: true });
    }
    this.el.nativeElement.value = value;
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    const value = input.value;

    // Allow only numeric input and navigation keys
    if (
      !/^[0-9]$/.test(key) &&
      !['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key)
    ) {
      event.preventDefault();
    }
  }
}
